import React, { ReactNode, useCallback, useState } from 'react'

interface Tip {
  x: number
  y: number
  content: ReactNode
}

const TIP_WIDTH = 270

/** Hover tooltip for chart marks: spread `bind(content)` on a mark and render `tooltip` once. */
export function useChartTooltip() {
  const [tip, setTip] = useState<Tip | null>(null)

  const bind = useCallback(
    (content: ReactNode) => ({
      onMouseMove: (e: React.MouseEvent) => setTip({ x: e.clientX, y: e.clientY, content }),
      onMouseLeave: () => setTip(null),
    }),
    [],
  )

  const tooltip = tip ? (
    <div
      role="tooltip"
      className="pointer-events-none fixed z-[100] max-w-[260px] rounded-[10px] bg-slate-900 px-3 py-2 font-['Roboto'] text-[13px] leading-[18px] text-white shadow-lg"
      style={{
        left: tip.x + 14 + TIP_WIDTH > window.innerWidth ? tip.x - TIP_WIDTH : tip.x + 14,
        top: tip.y + 16,
      }}
    >
      {tip.content}
    </div>
  ) : null

  return { bind, tooltip }
}

export const TipTitle: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="font-bold">{children}</div>
)

export const TipRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex justify-between gap-4 tabular-nums">
    <span className="opacity-75">{label}</span>
    <span>{value}</span>
  </div>
)
